export default __webpack_public_path__ + "static/revolutionizing-logistics-booking-management-f769b41dc5cd23173cc564dd1a22164c.png";